import { Component } from '@angular/core';

@Component({
  selector: 'app-isolate-resource-action',
  templateUrl: './isolate-resource-action.component.html',
  styleUrls: ['./isolate-resource-action.component.scss'],
})
export class IsolateResourceActionComponent {}
